module.exports = __webpack_public_path__ + "11f10198e675ebc5146f34c69a22a998.svg";